import styled from "styled-components";

const CommentContainer = styled.div`
  padding: 15px;
`;

export default CommentContainer;
